
import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";

const Pricing = () => {
  return (
    <section id="pricing" className="section bg-white">
      <div className="container-custom">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <h2 className="wallpaper-subtitle mb-6">
            Yksinkertainen, eleganttiä <span className="gradient-text">Hinnoittelu</span>
          </h2>
          <p className="text-wallpaper-gray max-w-2xl mx-auto font-wallpaper">
            Valitse verkkokaupallesi sopiva paketti 
            ilman piilokustannuksia tai pitkäaikaisia sitoumuksia.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          <PricingCard 
            title="Aloitus"
            price="499€"
            description="Täydellinen uusille tai pienille verkkokaupoille"
            features={[
              "1 räätälöity tekoälyagentti",
              "Perustason tuotetuntemus",
              "Normaali vasteaika",
              "Sähköpostituki",
              "Kuukausittaiset päivitykset"
            ]}
            buttonText="Aloita"
            buttonVariant="outline"
          />
          
          <PricingCard 
            title="Ammattilainen"
            price="999€"
            description="Ihanteellinen kasvaville verkkokaupoille"
            features={[
              "3 räätälöityä tekoälyagenttia",
              "Edistynyt tuotetuntemus",
              "Nopea vasteaika",
              "Sähköposti- ja chat-tuki",
              "Kahden viikon välein päivitykset",
              "Asiakaskäyttäytymisanalytiikka"
            ]}
            buttonText="Aloita"
            buttonVariant="default"
            highlighted={true}
          />
          
          <PricingCard 
            title="Yritys"
            price="Räätälöity"
            description="Suurille tai monitoimipisteen verkkokaupoille"
            features={[
              "Rajoittamaton määrä tekoälyagentteja",
              "Asiantuntijatason tuotetuntemus",
              "Välitön vasteaika",
              "Ensisijainen tuki",
              "Viikoittaiset päivitykset",
              "Edistynyt analytiikka ja raportointi",
              "Oma asiakkuuspäällikkö"
            ]}
            buttonText="Ota yhteyttä"
            buttonVariant="outline"
          />
        </div>
        
        <div className="mt-16 text-center">
          <p className="text-wallpaper-gray mb-4 font-wallpaper">
            Tarvitsetko räätälöidyn paketin verkkokauppasi tarpeisiin?
          </p>
          <Button variant="link" className="text-wallpaper-darkGray font-wallpaper uppercase tracking-wider text-sm">
            Ota yhteyttä myyntitiimiimme
          </Button>
        </div>
      </div>
    </section>
  );
};

interface PricingCardProps {
  title: string;
  price: string;
  description: string;
  features: string[];
  buttonText: string;
  buttonVariant: "default" | "outline";
  highlighted?: boolean;
}

const PricingCard = ({ 
  title, 
  price, 
  description, 
  features, 
  buttonText, 
  buttonVariant,
  highlighted = false 
}: PricingCardProps) => {
  return (
    <div className={`overflow-hidden ${highlighted ? 'shadow-lg' : 'border border-wallpaper-lightGray'}`}>
      {highlighted && (
        <div className="bg-wallpaper-darkGray text-white text-center py-2 text-xs font-wallpaper uppercase tracking-wider">
          Suosituin
        </div>
      )}
      <div className="p-8">
        <h3 className="text-lg font-light uppercase tracking-wider mb-4">{title}</h3>
        <div className="mb-6">
          <span className="text-3xl font-light">{price}</span>
          {price !== "Räätälöity" && <span className="text-wallpaper-gray text-sm">/kk</span>}
        </div>
        <p className="text-wallpaper-gray text-sm mb-8">{description}</p>
        
        <ul className="space-y-4 mb-8">
          {features.map((feature, index) => (
            <li key={index} className="flex items-start">
              <Check className="h-4 w-4 text-wallpaper-darkGray shrink-0 mr-3" />
              <span className="text-xs text-wallpaper-darkGray font-wallpaper">{feature}</span>
            </li>
          ))}
        </ul>
        
        <Button 
          variant={buttonVariant} 
          className={`w-full rounded-none ${
            buttonVariant === "default" ? "wallpaper-btn" : "wallpaper-btn-outline"
          }`}
        >
          {buttonText}
        </Button>
      </div>
    </div>
  );
};

export default Pricing;
